import {defineRouterCreator} from "@verdure/core";

export default defineRouterCreator({
    codeCreate: {
        title: '代码生成',
        type: 'view', // @ts-ignore
        component: () => import('../views/codeCreate/Index.vue'),
    },
});
